import { Component, AfterViewInit, ViewChild, Input,ElementRef, Output, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig, MatTableDataSource } from '@angular/material';
import { MatPaginator } from '@angular/material/paginator';
import { AuthService } from 'src/app/services/auth-service/auth.service';
import { merge, Observable, of as observableOf, Subject } from 'rxjs';
import { catchError, map, startWith, switchMap, takeUntil } from 'rxjs/operators';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { MessageService } from 'src/app/services/message/message.service';
import { FormControl } from '@angular/forms';
import { Location } from '@angular/common';
import { CoreServiceService } from 'src/app/services/core/core-service.service';
import { environment } from 'src/environments/environment';
import { ProfileComponent } from 'src/app/pages/profile/profile.component';


export interface searchFilter {
  transmitter: string;
  recipient: string;
  projectId: string;
  dateBefore: any;
  dateDeadline: any;
  dateAfter: any;
  tag: string;
  statut: boolean;
  type: string;
  keyWord: string;
  smartNumber: string;
}

@Component({
  selector: 'app-dashboardinstcontent',
  templateUrl: './dashboardinstcontent.component.html',
  styleUrls: ['./dashboardinstcontent.component.scss']
})
export class DashboardinstcontentComponent implements AfterViewInit, OnDestroy, OnInit {
 
  Math = Math;
  messages: any = [];
  dataSource: any;
  resultsLength = 0;
  perPage = 30;
  isLoadingResults = false;
  isRateLimitReached = false;
  lastDate = new Date('01/01/4970');
  filterChoosen = null;
  firstLoad = true;

  displayedColumns: string[] = [
    'Date',
    'Expéditeur',
    'Projet',
    'consult'
  ];
  
  hiddenSearchEngin = true;
  projectDocSenders = [];
  projectDocSendersInit = [];
  @Output() projectsLoadedInstant = new EventEmitter<any[]>();
  @Output() sendersLoadedInstant = new EventEmitter<any[]>();
  @Output() typesLoadedInstant = new EventEmitter<any[]>();

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild('journalWrapper', { static: false }) journalWrapper: ElementRef;
  currentPage = 1;

  @Output() EventLaunchSearch = new EventEmitter();
  @Output() EventLaunchSearchDoc = new EventEmitter();
  @Output() EventLaunchFilter = new EventEmitter();
  @Input() ged: boolean = false;

  transmitter = null;
  recipient = null;
  projectId = null;
  dateBefore = null;
  dateAfter = null;
  dateDeadline = null;
  tag = null;
  statut = null;
  type = null;
  keyWord = null;
  smartNumber = null;
  modeDoc = false;
  //contacts: Array<any> = [];
  contactsExp: Array<any> = [];
  contactsDest: Array<any> = [];
  projectLists: Array<any> = [];
  projectTags: any;
  chosenFilter: searchFilter;
  currentUser = null;
  saveCtc = null;
  saveCtcTransmitter = null;
  saveProject = null;
  saveTheme   = null;
  secteur = "";
  public transmitterCtrl: FormControl = new FormControl();
  public recipientCtrl: FormControl = new FormControl();
  public projectCtrl: FormControl = new FormControl();
  public themeCtrl: FormControl = new FormControl();
  protected _onDestroy = new Subject<void>();
  recentProject = null;
  hideNav = Number(localStorage.getItem('hideNav'));
  searchstep = "init";
  searchproject = "Groupe";
  searchsender = "Émetteur";
  searchtype = "Type de Document";
  
  transmitterinstant: string;
  typeinstant: string;
  searchtypes = [];
  searchtypesfilter = [
    {id: "pdf", nom: "Pdf", image: "search-pdf"},
    {id: "excel", nom: "Excel", image: "search-excel"},
    {id: "word", nom: "Word", image: "search-word"},
    {id: "presentation", nom: "Présentation", image: "search-presentation"},
    {id: "image", nom: "image", image: "search-image"},
    {id: "video", nom: "Vidéo", image: "search-video"},
    {id: "http", nom: "Lien", image: "search-lien"}
  ]
  searchtypesApi = [];
  filtersenderins = "alpha";
  filterproject = "alpha";
  projectInit = [];
  filterprojectf = "date";
  projectSendersInit = [];
  searchProjectIns : any = null;
  searchSender : any = null;
  searchresLength = 0;
  targetValue: number = 0;
  intervalId: any;
  private refreshSearchObs = new Subject();
  filterChoosenSearch= null;
  animate = false;
  name: string;
  profile: string;
  commonRef: string;
  vibrantColors = [
    "#e7e0ff", 
    "#caf1ee", 
    "#fff0d3", 
    "#fbd8dc", 
    "#d8fdd2", 
    "#f4ded1", 
    "#d1e8ff", 
    "#cbf2ef"
  ];

  colorMap: Record<string, string> = {
    '#e7e0ff': '#5d45de', 
    '#caf1ee': '#008476', 
    '#fff0d3': '#9d6b2b', 
    '#fbd8dc': '#cd0635', 
    '#d8fdd2': '#1c8555', 
    '#f4ded1': '#855436', 
    '#d1e8ff': '#0060d3', 
    '#cbf2ef': '#008379'  
  };
  private destroy$ = new Subject<void>();
  hoveredOption: 'chat' | 'face' | null = null;
  stat_projects = 0;

  constructor(private location: Location, public dialog: MatDialog, private coreService: CoreServiceService, private authService: AuthService, private router: Router, private route: ActivatedRoute, private messageService: MessageService) { 
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    delete currentUser.token;
    delete currentUser.refresh_token;
    delete currentUser.roles;
    this.currentUser = currentUser;
    this.route.queryParams.subscribe(params => {
      this.recentProject = params['projet'];
    });
  }


  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(){
    this.authService.setMode('collaboratif');
    this.getAllMessages(null);
    this.secteur = localStorage.getItem('secteur');
  
    this.loadTypes();
    this.getContact();
    this.loadProject();
    this.loadDocsSendersIns();
    this.getStats();

    this.authService.closeBloc.subscribe((term) =>{ 
      if(term == 1){
        this.resetSearch();
      }
      //console.log('dans le smarnumber idmessage ==> '+idMessage);
    });

    this.authService.obprojectChosen.subscribe((idMessage) =>{ 
      this.smartNumber = idMessage;
      //console.log('dans le smarnumber idmessage ==> '+idMessage);
    });

    this.authService.changeModeProject
    .pipe(takeUntil(this.destroy$))
    .subscribe(res => {
      if (res === 'change') {
        this.redirectToHistoFace();
      }
    });

    this.coreService.toggleSidebar.subscribe((res) => {
      this.hideNav = Number(res);
    });

    this.ged = false;
    this.hiddenSearchEngin = true;

  }

  loadDocsSendersIns(){
    this.authService.getDocsExpInstant().subscribe(res => {
      this.projectDocSenders = res['hydra:member'];
      this.projectDocSendersInit = this.projectDocSenders;
      this.sendersLoadedInstant.emit(this.projectDocSendersInit);
    }, (error) => {
    });
  }

  getStats(){
    this.authService.getGlobalStats().subscribe(  
    (success) => {
     
      var dataArray = success['hydra:member'];
      this.stat_projects = dataArray.totalProject;
    },
    (error) => {
      alert('Erreur global stats ! : ' + error)
    });
   }

  ngAfterViewInit() {  

    this.recipientCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterRecipient();
      });

    this.transmitterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterTransmitter();
    });


    this.projectCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterProject();
      });

    this.themeCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.themeProject();
      });
   

  }

  getAvatarlUrl(avatarLink){
    return environment.server_url+avatarLink;
  }

  getProjectImage(avatarLink){
    return environment.server_url+"/media/project_img/"+avatarLink;
  }

  getContactImage(avatarLink){
    return environment.server_url+"/media/profil/"+avatarLink;
  }

  initFilterProject(){
    this.EventLaunchFilter.emit('all');
  }

  redirectToHistoFace(){
    this.router.navigate(['/dashboard']);
  }


 loadFilterElement(){
    //console.log("on loadFilterElement");
    if (this.firstLoad == true) {
      this.getContact();
      this.loadProject();
    }
    this.firstLoad = false;
  }

  fcthiddenSearchEngin(){
    if (this.hiddenSearchEngin == false)
      this.hiddenSearchEngin = true;
    else
      this.hiddenSearchEngin = false;
  }

  protected filterRecipient() {
    if(this.saveCtc == null){
      this.saveCtc = this.contactsDest;
    }

    let search = this.recipientCtrl.value;
    if (!search) {
      this.contactsDest = this.saveCtc;
      return;
    } else {
      search = search.toLowerCase();
      this.contactsDest = this.saveCtc.filter(bank => bank.givenName.toLowerCase().indexOf(search) > -1 || bank.familyName.toLowerCase().indexOf(search) > -1 );
    }
  }

  protected filterTransmitter(){
    if(this.saveCtcTransmitter == null){
      this.saveCtcTransmitter = this.contactsExp;
    }

    let search = this.transmitterCtrl.value;
    if (!search) {
      this.contactsExp = this.saveCtcTransmitter;
      return;
    } else {
      search = search.toLowerCase();
      this.contactsExp = this.saveCtcTransmitter.filter(bank => bank.givenName.toLowerCase().indexOf(search) > -1 || bank.familyName.toLowerCase().indexOf(search) > -1 );
    }
  }

  protected filterProject() {
    if(this.saveProject == null){
      this.saveProject = this.projectLists;
    }

    let search = this.projectCtrl.value;
    if (!search) {
      this.projectLists = this.saveProject;
      return;
    } else {
      search = search.toLowerCase();
      this.projectLists = this.saveProject.filter(bank => bank.libelle.toLowerCase().indexOf(search) > -1);
    }
  }

  protected themeProject() {
    // console.log("calling themeProject");
    if(this.saveTheme == null){
      this.saveTheme = this.projectTags;
      // console.log("in themeProject", this.saveTheme);
    }else{
      // console.log("else themeProject", this.projectTags);
    }

    let search = this.themeCtrl.value;
    if (!search) {
      this.projectTags = this.saveTheme;
      return;
    } else {
      search = search.toLowerCase();
      this.projectTags = this.saveTheme.filter(bank => bank.libelle.toLowerCase().indexOf(search) > -1);
    }
  }

  calculateDate(date) {
    var result = 0;
    var today = new Date().setHours(0, 0, 0, 0);
    var yesterday = new Date(new Date().setDate(new Date().getDate()-1)).setHours(0, 0, 0, 0);
    date = new Date(date);
    if (date >= today) {
      result = 1;
    } else if (date >= yesterday) {
      result = 2;
    } else result = 3;
    return result;
  }

  filterProjectF(val : any){
    this.filterprojectf = val;
    if(val == "date"){
        this.projectInit.sort((a, b) => {
          if ( a.dateCreated > b.dateCreated ){
            return -1;
          }
          if ( a.dateCreated < b.dateCreated ){
            return 1;
          }
          return 0;
        })
        /*this.projectInit.sort((a, b) => {
          if ( a.lastinstant > b.lastinstant ){
            return -1;
          }
          if ( a.lastinstant < b.lastinstant ){
            return 1;
          }
          return 0;
        })*/
    } else {
      this.projectInit.sort((a, b) => {
        if ( a.libelle.toLowerCase() < b.libelle.toLowerCase() ){
          return -1;
        }
        if ( a.libelle.toLowerCase() > b.libelle.toLowerCase() ){
          return 1;
        }
        return 0;
      })
    }
  }

  filterSenders(val : any){
    this.filtersenderins = val;
    if(val == "date"){
        this.projectSendersInit.sort((a, b) => {
          if ( a.createdAt > b.createdAt ){
            return -1;
          }
          if ( a.createdAt < b.createdAt ){
            return 1;
          }
          return 0;
        })
    } else {
      this.projectSendersInit.sort((a, b) => {
        if ( a.fullName.toLowerCase() < b.fullName.toLowerCase() ){
          return -1;
        }
        if ( a.fullName.toLowerCase() > b.fullName.toLowerCase() ){
          return 1;
        }
        return 0;
      })
    }
  }

  onSearchProject() {
    if (this.searchProjectIns.trim() === '' || this.searchProjectIns == null) {
      this.searchProjectIns = null;
      this.projectInit = this.projectLists;
      this.filterProjectF(this.searchProjectIns);
    } else {
      var search = this.searchProjectIns.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      this.projectInit = this.projectLists.filter(bank => bank.libelle.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(search) > -1);
    }
  }

  onSearchSenderF() {
    if (this.searchSender.trim() === '' || this.searchSender == null) {
      this.searchSender = null;
      this.projectSendersInit = this.contactsExp;
      this.filterSenders(this.filtersenderins);
    } else {
      var search = this.searchSender.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      this.projectSendersInit = this.contactsExp.filter(bank => bank.fullName.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(search) > -1 || bank.familyName.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(search) > -1 );
    }
  }
  

  dataMap(data: any, first = false) {

    var strId = data['project']['@id']; 
    var splittedID = strId.split("/"); 
    var idProject = splittedID[splittedID.length-1];  
    //var listTag : any[] = data['tags'];
    var date = data['dateCreated']; 
    var isNewDay = this.isNewDay(date);

    const message: any = {
      'id': idProject,
      'idmsg': data['id'],
      'project': data['project'],
      'first': first,
      //'tag': (listTag[0] ? listTag[0].libelle  : '' ),
      'date': date,
      'typeParse': 'QUESTION',
      'type': data['type'],
      'sender': (data['author'] ? data['author'] : ''),
      'smartNumber': data['smartNumber'],
      'filegeneric': data['filegeneric'],
      'isNewDay' : isNewDay
    };

    return message;
  }

 public getAllMessages(searchChoose) {

    this.paginator.pageIndex = 0;
    this.filterChoosen = searchChoose;

    merge(this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.authService.getAllInstMessages(this.paginator.pageIndex, this.perPage, this.filterChoosen);
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;    

          this.resultsLength = data['hydra:totalItems']; 
          this.searchresLength = 0;

          return data['hydra:member'];
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data => { 
        //console.log({test1111:data})
        //console.log('contenu de data '+ JSON.stringify(data));
        this.messages = [];
        this.lastDate = new Date('01/01/4970');
        data=data.filter(item=>!item.action)
        var j = 0;
        var first = false;
        data.forEach(element => {
          j++;
          if(j == 1) first = true;
          this.messages.push(this.dataMap(element, first));
          first = false;
        });

        let afterIsNewDay = false;
        this.messages.reverse().forEach((element, index) => {
          if(afterIsNewDay || index == 0){
            this.messages[index]["afterIsNewDay"] = true;
            afterIsNewDay = false;
            //console.log("afterIsNewDay")
          }
          if(element.isNewDay == true){
            afterIsNewDay = true;
          }
        });

        this.dataSource = this.messages.reverse(); 
         

      });

      merge(this.refreshSearchObs)
      .pipe(
        startWith({}),
        switchMap(() => {
          return this.authService.getAllInstMessages(this.paginator.pageIndex, this.perPage, this.filterChoosenSearch);
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.targetValue = data['hydra:totalItems'];
        }),
        catchError(() => {
          return observableOf([]);
        })
      ).subscribe(data => { 
        if(this.checkSearchInitIns()) this.animateToValue(0);
        else this.animateToValue(this.targetValue);
      });

  }

  filterMessageCount(ged = null){
    this.animate = true;
    this.filterChoosenSearch = { 
        transmitter: this.transmitter,
        projectId: this.projectId,
        type: this.type,
        dateBefore: this.dateBefore,
        dateAfter: this.dateAfter,
        keyWord: (this.keyWord ? this.keyWord.trim() : null),
        smartNumber: this.smartNumber
    };
    this.refreshSearchObs.next();
  }

  animateToValue(newValue: number) {
    if (newValue == this.searchresLength) return;
  
    const step = newValue > this.searchresLength ? 1 : -1;
  
    // Durée totale de l'animation (ici 1 seconde, à ajuster si nécessaire)
    const animationDuration = 1000; // 1000 ms = 1 seconde
    const totalSteps = Math.abs(newValue - this.searchresLength); // nombre d'incréments nécessaires
    const stepDuration = animationDuration / totalSteps; // durée de chaque incrément
  
    let startTime = performance.now(); // Horodatage au début de l'animation
    let lastStepTime = startTime; // Temps du dernier "step" effectué
    let currentStep = 0; // Compteur des étapes réalisées
  
    const animate = (currentTime: number) => {
      const elapsed = currentTime - startTime; // Temps écoulé depuis le début de l'animation
      const progress = Math.min(elapsed / animationDuration, 1); // Calcul du progrès de l'animation
  
      // Nombre d'étapes réalisées jusqu'à maintenant, basé sur le temps écoulé
      currentStep = Math.floor(progress * totalSteps);
  
      // Si une nouvelle étape doit être effectuée
      if (currentTime - lastStepTime >= stepDuration) {
        this.searchresLength = this.searchresLength + step;
        lastStepTime = currentTime; // Mettre à jour le temps du dernier step
  
        // Si la cible est atteinte, on s'assure que la valeur finale est atteinte
        if ((step === 1 && this.searchresLength >= newValue) || (step === -1 && this.searchresLength <= newValue)) {
          this.searchresLength = newValue;
        }
      }
  
      // Si l'animation n'est pas encore terminée, on continue l'animation
      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        // À la fin de l'animation, on s'assure que la valeur finale est bien celle attendue
        this.searchresLength = newValue;
      }
    };
  
    // Démarre l'animation
    requestAnimationFrame(animate);
  }

  isRoundFirst(afterIsNewDay, isNewDay){
    if(afterIsNewDay && isNewDay){
      return "divcontaine afterIsNewDayBL afterIsNewDayTL";
    }else if(afterIsNewDay){
      return "divcontaine afterIsNewDayBL";
    }else if(isNewDay){
      return "divcontaine afterIsNewDayTL";
    }
    return "divcontaine";
  }

  isRoundLast(afterIsNewDay, isNewDay){
    if(afterIsNewDay && isNewDay){
      return "divcontaine afterIsNewDayBR afterIsNewDayTR";
    }else if(afterIsNewDay){
      return "divcontaine afterIsNewDayBR";
    }else if(isNewDay){
      return "divcontaine afterIsNewDayTR";
    }
    return "divcontaine";
  }

  isNewDay(messageDate){
    let currentDate = new Date(messageDate.substring(0,10)); 
    //console.log('this.lastDate ==> '+this.lastDate);
    //console.log('currentDate ==> '+currentDate);
    if(currentDate < this.lastDate)
    {
      // console.log('Une section ==> '+ currentDate);
      this.lastDate = currentDate;
      return true;
    } 
    else
    { 
      this.lastDate = currentDate; 
      return false;
    }
  }

  getReceiver(recipientid){
    if(this.projectId){
      this.authService.getRecipientsBySender(this.projectId, recipientid).subscribe(res => {
        var tmpArrayUser = res['hydra:member'];
        this.contactsDest = [];
        for (var i = 0; i < tmpArrayUser.length; i++) {
          if(tmpArrayUser[i].id){
            this.contactsDest.push(tmpArrayUser[i]);
          }
        }
        this.contactsDest.sort(this.compare);
      }, (error) => {
         //console.log(' getTheProject subscribe error '+error.statusText);
      });
    } else {
      this.authService.getAllRecipientsBySender(recipientid).subscribe(res => {
        var tmpArrayUser = res['hydra:member'];
        this.contactsDest = [];
        for (var i = 0; i < tmpArrayUser.length; i++) {
          if(tmpArrayUser[i].id){
            this.contactsDest.push(tmpArrayUser[i]);
          }
        }
        this.contactsDest.sort(this.compare);
      }, (error) => {
        //console.log(' getTheProject subscribe error '+error.statusText);
      });
    }
  }

  getContact(){
    //this.loadContact();

    this.authService.getContactsExpInstant(this.projectId).subscribe(res => {
      this.contactsExp = [];
      var tmpArrayUser = res['hydra:member'];
      for (var i = 0; i < tmpArrayUser.length; i++) {
        this.contactsExp.push(tmpArrayUser[i]);
      }
      this.contactsExp.sort(this.compare);
      this.contactsExp.forEach(element => {
        const randomIndex = Math.floor(Math.random() * this.vibrantColors.length);
        element.color = this.vibrantColors[randomIndex];
      });
      this.projectSendersInit = this.contactsExp;
    }, (error) => {
         //console.log(' getTheProject subscribe error '+error.statusText);
    });

  }

  /*loadContact(url?: string){
    url = url ? url : undefined;
    this.authService.getContacts(url).subscribe(res => {
      this.contacts = this.contacts.concat(res['hydra:member']);
      
      if(this.contacts.length && this.contacts[0].id != this.currentUser.id){
        this.contacts.unshift(this.currentUser);
      }
      this.contacts.sort(this.compare);

      if(res['hydra:view']['hydra:next']){
        this.loadContact(res['hydra:view']['hydra:next'].replace("/api", ""));
      }
    }); 
  }*/

  compare( a, b ) {
    if ( a.givenName.toLowerCase() < b.givenName.toLowerCase() ){
      return -1;
    }
    if ( a.givenName.toLowerCase() > b.givenName.toLowerCase() ){
      return 1;
    }
    return 0;
  }

  loadTypes(url?: string){
    this.searchtypesApi = [];
    this.authService.getMessageTypesIns(this.projectId, this.transmitter).subscribe(res => {
      this.searchtypesApi = this.searchtypesApi.concat(res['hydra:member']);
      this.searchtypes = this.searchtypesfilter.filter(item => this.searchtypesApi.includes(item.id));
      if(!this.projectId && !this.transmitter) {
        this.typesLoadedInstant.emit(this.searchtypes);
      }
    }); 
  }

  getRandomColor(): string {
    const randomIndex = Math.floor(Math.random() * this.vibrantColors.length);
    return this.vibrantColors[randomIndex];
  }

  darkenColor(bgColor: string) {
    if (!bgColor) return '#444';
    const key = bgColor.toLowerCase().substring(0, 7);
    return this.colorMap[key] || '#444'
  }

  getInitials(libelle: string): string {
    const words = libelle.split(' ');
    const getFirstChar = (word: string): string => {
      return word.trim().charAt(0).toUpperCase();  // Récupère le premier caractère du mot
    };
    const initials = words.slice(0, 2).map(word => getFirstChar(word)).join('');  // Joint avec un point

    return initials;
  }

  loadProject(url?: string){
    url = url ? url : undefined;
    this.authService.getProjectsMessagesIns().subscribe(res => {
      this.projectLists = this.projectLists.concat(res['hydra:member']);
      /*this.projectLists = this.projectLists.sort(function (a, b) {
          if (a.libelle.toLowerCase() < b.libelle.toLowerCase()) { return -1; }
          if (a.libelle.toLowerCase() > b.libelle.toLowerCase()) { return 1; }
          return 0;
      })
      if(res['hydra:view']['hydra:next']){
        this.loadProject(res['hydra:view']['hydra:next'].replace("/api", ""));
      }*/
     this.projectInit.sort((a, b) => {
          if ( a.dateCreated > b.dateCreated ){
            return -1;
          }
          if ( a.dateCreated < b.dateCreated ){
            return 1;
          }
          return 0;
      })
      this.projectInit = this.projectLists;
      this.projectsLoadedInstant.emit(this.projectInit);
      this.projectInit.forEach(project => {
        project.randomColor = this.getRandomColor();
      });
    }); 
  }

  getSujet(idProject){
    this.projectId = idProject;
    //this.search()
    if (idProject) {
      this.authService.getTheProject(idProject).subscribe(res => {
        this.projectTags = res['tags'];
        }, (error) => {
         //console.log(' getTheProject subscribe error '+error.statusText);
      });

      /*
      this.authService.getContactsExpID(idProject).subscribe(res => {
        this.contactsExp = [];
        this.contactsExp = res['hydra:member'];
        this.contactsExp.sort(this.compare);
      }, (error) => {
      });*/

      /*
      this.authService.getContactsRecipID(idProject).subscribe(res => {
        var tmpArrayUser = res['hydra:member'];
        this.contactsDest = [];
        for (var i = 0; i < tmpArrayUser.length; i++) {
          if(tmpArrayUser[i].id){
            this.contactsDest.push(tmpArrayUser[i]);
          }
        }
        this.contactsDest.sort(this.compare);
      }, (error) => {
         //console.log(' getTheProject subscribe error '+error.statusText);
      });*/
    }
  }

  changeBetweenFilGed(){
    this.initAttributesInstant();
    if(this.modeDoc == false) {
      console.log("initAttributesInstant false")
      this.launchSearchDoc();
    } else {
      console.log("initAttributesInstant true")
      this.modeDoc = false;
      this.EventLaunchSearch.emit(this.chosenFilter);
      //this.launchSearchInstant();
    }
  }

  

  initAttributesInstant(){
    this.transmitter = null;
    this.projectId = null;
    this.dateBefore  = null;
    this.dateAfter  = null;
    this.type = null;
    this.keyWord = null;
    this.smartNumber = null;
  }


  search(){
    if(this.modeDoc){
      this.launchSearchDoc()
    }else{
      this.launchSearch()
    }
  }
  
  launchSearch(ged = null){

    this.modeDoc = false;
    //if(!ged) this.hiddenSearchEngin = true;
    

    this.chosenFilter = { 
      transmitter: this.transmitter,
      recipient: this.recipient,
      projectId: this.projectId,
      dateBefore: this.dateBefore,
      dateAfter: this.dateAfter,
      dateDeadline: this.dateDeadline,
      tag: this.tag,
      statut: this.statut, 
      type: this.type,
      keyWord: (this.keyWord ? this.keyWord.trim() : null),
      smartNumber: this.smartNumber
    };
    this.EventLaunchSearch.emit(this.chosenFilter);

  }

  launchSearchDoc(){
    if(this.type=="http") {
      alert("Vous ne pouvez pas sélectionner le type lien pour rechercher un document");
      return;
    }
    this.modeDoc = true;

    this.chosenFilter = { 
      transmitter: this.transmitter,
      recipient: this.recipient,
      projectId: this.projectId,
      dateBefore: this.dateBefore,
      dateDeadline: this.dateDeadline,
      dateAfter: this.dateAfter,
      tag: this.tag,
      statut: this.statut,
      type: this.type, 
      keyWord: (this.keyWord ? this.keyWord.trim() : null),
      smartNumber: "instant"
    };
    //console.log(' launchSearchDoc '+ JSON.stringify(this.chosenFilter) );
    //this.fcthiddenSearchEngin();
    this.EventLaunchSearchDoc.emit(this.chosenFilter);

  }

  checkSearchInitIns(){
    if(this.projectId == null && this.transmitter == null  && this.dateBefore == null && this.dateAfter == null && this.type == null && this.keyWord == null){
      return true;
    } else {
      return false;
    }
  }

  public resetSearch(){

    this.transmitter = null;
    this.projectId = null;
    this.dateBefore  = null;
    this.dateAfter  = null;
    this.type = null;
    this.keyWord = null;
    this.smartNumber = null;
    this.launchSearch("1");
    this.resetSearchIns();

    /*
    if(this.modeDoc == false) 
    {
      this.launchSearch();
    }
    else
    {
      this.launchSearchDoc();
    }*/
    this.getContact();

  }

  

  openProfilDialog() {
    this.dialog.closeAll();
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'contactpanel';
    dialogConfig.id = 'balchal718';
    dialogConfig.width = '550px';
    dialogConfig.autoFocus = false;
    dialogConfig.data = { name: this.name, profile: this.profile, commonRef: this.commonRef };
    //const dialogRef = this.dialog.open(ProfileComponent, dialogConfig);
    const dialogRef = this.dialog.open(ProfileComponent, {
      data: { name: this.name, profile: this.profile, commonRef: this.commonRef },
      panelClass: 'transferclass',
      backdropClass: 'custom-backdrop'
    });

    dialogRef.afterClosed().subscribe((result: any) => {
    });

  }


  public refreshInfoFilter(){
    this.getContact();
    this.loadProject();  
  }

  goBack(){
    this.location.back();
    //this.router.navigate(['/project/'+this.recentProject+'/openmsg']);
    //window.history.back();
  }

  initProject(item = null){
    this.searchproject = "Groupe";
    this.projectId = null; 
    this.getContact();
    this.loadTypes();
    this.initSender('1');
    this.initType('1');
    if(!item) this.selectChoice("init");
    this.filterMessageCount();
  }

  initSender(item = null){
    this.searchsender = "Émetteur";
    this.transmitter = null; 
    if(!item) this.selectChoice("init");
    this.filterMessageCount();
    this.initType('1');
    this.loadTypes();
  }

  initType(item = null){
    this.searchtype = "Type de Document";
    this.type = null; 
    if(!item) this.selectChoice("init");
    this.filterMessageCount();
  }

  selectChoice(item = "init"){
    if(this.searchstep == "init" && item == "init") {
      this.fcthiddenSearchEngin();
    } else this.searchstep = item;
  }

  selectSender(givenname, familyname, id){
    this.searchsender = givenname + familyname;
    this.transmitter = id; 
    this.getReceiver(id);
    this.loadTypes();
    this.selectChoice("init");
    this.filterMessageCount();
  }

  selectProject(libelle, id){
    this.searchproject = libelle;
    this.projectId = id;
    this.filtersenderins = 'alpha'
    //this.loadFilterElement();
    //this.getSujet(id);
    this.getContact();
    this.loadTypes();
    this.selectChoice("init");
    this.filterMessageCount();
  }

  selectType(libelle, id){
    this.searchtype = libelle;
    this.selectChoice("init");
    this.type = id; 
    this.filterMessageCount();
  }

  onDateBeforChange(newDate: any): void {
    this.dateBefore = newDate;
    this.filterMessageCount();
  }

  onDateAfterChange(newDate: any): void {
    this.dateAfter = newDate;
    this.filterMessageCount();
  }

  resetSearchIns(){
    this.searchproject = "Groupe";
    this.searchsender = "Émetteur";
    this.searchtype = "Type de Document";
  }

  searchResetInstant(){
    this.resetSearchIns();
    this.resetSearch();
  }

  goToPage(page: number) {
  if (page < 1 || page > Math.ceil(this.resultsLength / this.perPage)) return;
  this.currentPage = page;
  this.paginator.pageIndex = page - 1; // MatPaginator est 0-indexé
  this.paginator.page.emit({
    pageIndex: page - 1,
    pageSize: this.perPage,
    length: this.resultsLength
  });
  if(this.journalWrapper && this.journalWrapper.nativeElement) this.journalWrapper.nativeElement.scrollIntoView({block: "start"});
  //document.getElementById('journalWrapper')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

getPageNumbers(): (number | string)[] {
  const total = Math.ceil(this.resultsLength / this.perPage);
  const current = this.currentPage;
  const pages: (number | string)[] = [];

  if (total <= 7) {
    for (let i = 1; i <= total; i++) pages.push(i);
    return pages;
  }

  pages.push(1);
  if (current > 3) pages.push('...');

  const start = Math.max(2, current - 1);
  const end = Math.min(total - 1, current + 1);
  for (let i = start; i <= end; i++) pages.push(i);

  if (current < total - 2) pages.push('...');
  pages.push(total);

  return pages;
}




}



